export default "__VITE_ASSET__g5e3ToSR__"